import withUrlParams from '../../../../hoc/withUrlParams'
import InitialLoading from './component'

export default withUrlParams(InitialLoading)
